class NavigateAdaptor {
  constructor(navigate) {
    this.navigate = navigate
  }

  replace(obj) {
    this.navigate(obj.url, { replace: true })
  }
  push(obj) {
    this.navigate(obj.url)
  }
  open(obj) {
    window.open(obj.url)
  }
  jump(obj) {
    window.location.href = obj.url
  }
  getCurrentLocation() {
    return window.location.pathname + window.location.search
  }
}

export default NavigateAdaptor
